// Formatação ÚNICA da data de plano (vencimento / próxima cobrança / fim) — DD/MM/AAAA.
//
// Usa os componentes de calendário UTC do timestamp. Os end_date/next_charge_date do backend
// representam o DIA pretendido (gravados em UTC). Renderizar no fuso local do navegador (BRT, -3)
// deslocaria uma data gravada à meia-noite UTC para o dia ANTERIOR (ex.: 04/07 viraria 03/07).
// Pegar o dia UTC mostra o dia pretendido, idêntico em todo o app (Sidebar, Meu Plano, Config).
export function formatPlanDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = d.getUTCFullYear();
  return `${dd}/${mm}/${yyyy}`;
}
